import React, { useState } from 'react';
import './Inquiry.css'; 
import { useNavigate } from 'react-router-dom';

const Inquiry = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false); // 送信済みかどうか


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (submitted) return;
    setLoading(true);

    const requestBody = {
      type: "inquiry", 
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };
    setSubmitted(true);

    try {
      const response = await fetch('https://0d17oeeh23.execute-api.ap-northeast-1.amazonaws.com/prod/inquiryHandler-prod', {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      setFormData({ name: '', email: '', message: '' });
      const result = await response.json();
  
      if (response.ok) {
        switch (result.action) {
          case "submit":
            navigate("/InquiryComplete"); 
            break;
        }
      } else {
          navigate("/UnexpectedError");
      }
    } catch (error) {
      navigate("/UnexpectedError");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container_inquiry">
      <h2 className="h2_inquiry">お問い合わせ</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="label_inquiry" htmlFor="name">名前:</label>
          <input
            className="input_inquiry"
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="お名前を入力してください"
            required
          />
        </div>
        <div className="form_inquiry">
          <label className="label_inquiry" htmlFor="email">メールアドレス:</label>
          <input
            className="input_inquiry"
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="メールアドレスを入力してください"
            required
          />
        </div>
        <div className="form-group">
          <label className="label_inquiry" htmlFor="message">本文:</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="お問い合わせ内容を入力してください"
            required
            rows={5}
          ></textarea>
        </div>
        <div className="consent">
              <p className="consent_p">
                <a href="/PersonalInfomation.html" target="_blank" rel="noopener noreferrer">個人情報の取り扱いについて</a>
              </p>
              <div className="checkbox-group">
                <input 
                  type="checkbox"
                  name="consent"
                  value="consent"
                  required
                />
                <label className="mail_p">個人情報の取り扱いに同意する</label>
              </div>
            </div>
      <button className="btn_inquiry" type="submit" disabled={loading || submitted}>
        {loading ? "送信中..." : submitted ? "送信" : "送信"}
      </button>
      </form>
    </div>
  );
};

export default Inquiry;
